import styled from "styled-components";

interface TRStyleProps {
    isOpen: boolean;
    rows: number;
}
export const TRStyle = styled.div<TRStyleProps>`
    display: grid;
    grid-template-columns: repeat(${(props) => props.rows}, 1fr);
    width: 100%;
    background:  ${props => (props.isOpen ? "#E5E5E5" : "transparent")};
    border-radius: ${props => (props.isOpen ? "10px 10px 0 0" : "10px")};
    border: 1px solid #C4C4C4;
    border-bottom: ${props => (props.isOpen ? "1px solid transparent" : "1px solid #C4C4C4")};
    transition: background 0.2s ease-in-out;
    padding: 15px 12px;
    margin-bottom: ${props => (props.isOpen ? "0" : "13px")};
    cursor: pointer;
    position: relative;

    &:first-child{
        margin-top: 10px;
    }
    
    &:hover {
        background-color: #E5E5E5;
    }

    .icon{
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        right: 20px;
        top: calc(50% - 6px);
        ${props => (props.isOpen ? "transform: rotate(-180deg);" : "")}
        transition: all 0.2s ease-in-out;
    }

`

interface TRStyleContentProps {
    isOpen: boolean;
}
export const TRStyleContent = styled.div<TRStyleContentProps>`
    padding-top: 14px;
    border: 1px solid #C4C4C4;
    border-radius: 0px 0px 10px 10px;
    margin-bottom: ${props => (props.isOpen ? "13px" : "0")};
`